import { useState, useCallback, useEffect } from "react";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";

import ErrorResponseDto from "dto/services/error-response-dto";
import { ContentTypeObj } from "dto/services/recipient-email/recipient-email-array-input-response-dto";

import AppHeading from "components/app-heading";
import AppRecipientEmailArrayInput from "components/pages/page-recipient-email/app-recipient-email-array-input";

const PageRecipientEmail = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [activeTemplate, setActiveTemplate] = useState<string>("");
	const [recipientEmails, setRecipientEmails] = useState<ContentTypeObj[]>([]);

	const onHandleGetActiveTemplate = useCallback(async () => {
		setIsLoading(true);

		try {
			const response = await api.get.resources.activeTemplate();

			if (response) setActiveTemplate(response.data?.data || "");
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);

			setIsLoading(false);
		}
	}, []);

	const onHandleGetRecipientEmails = useCallback(async () => {
		setIsLoading(true);

		try {
			const payload = { template: activeTemplate };
			const response = await api.get.emails.emails(payload);

			if (response) {
				setRecipientEmails(response.data.data?.contents);
			}
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);

			setIsLoading(false);
		}
	}, [activeTemplate]);

	useEffect(() => {
		onHandleGetActiveTemplate();
	}, [onHandleGetActiveTemplate]);

	useEffect(() => {
		if (activeTemplate) onHandleGetRecipientEmails();
	}, [activeTemplate, onHandleGetRecipientEmails]);

	return (
		<div className="page-recipient-email">
			<div className="recipient-email">
				<AppHeading title="Recipient Email">
					<AppHeading.Divider />
				</AppHeading>

				{recipientEmails.length > 0 &&
					recipientEmails.map((content, index) => {
						const emailRecipient = content.value?.find((item: any) => item.key === "email.recipient");
						if (!emailRecipient) return null;

						return (
							<div key={`${content.page}-${index}`} className="form">
								<AppRecipientEmailArrayInput detail={{ ...emailRecipient, page: content.page, template: activeTemplate }} />
							</div>
						);
					})}

				{!isLoading && recipientEmails.length === 0 && <p className="recipient-email__text">No Record Found</p>}
			</div>
		</div>
	);
};

export default PageRecipientEmail;
